import * as ng from 'angular';

declare var window: any;

export const PostRepeatDirective: ng.IDirectiveFactory = ($timeout: ng.ITimeoutService) => {
    return (scope: any) => {
        if (scope.$first) {
            window.a = new Date();   // window.a can be updated anywhere if to reset counter at some action if ng-repeat is not getting started from $first
        }
        if (scope.$last) {
            $timeout(() => {
                // ?
            });
        }
    };
};

PostRepeatDirective.$inject = ['$timeout'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/post-repeat-directive/post-repeat-directive.directive.ts